export interface UserBrandProps {
  brandKey: string;
  brandName: string;
  brandLogo: string | null;
  organizationKey: string;
  organizationName: string;
  organizationLogo: string | null;
}

export class UserBrand {
  private readonly _brandKey: string;
  private readonly _brandName: string;
  private readonly _brandLogo: string | null;
  private readonly _organizationKey: string;
  private readonly _organizationName: string;
  private readonly _organizationLogo: string | null;

  constructor(props: UserBrandProps) {
    this._brandKey = props.brandKey;
    this._brandName = props.brandName;
    this._brandLogo = props.brandLogo;
    this._organizationKey = props.organizationKey;
    this._organizationName = props.organizationName;
    this._organizationLogo = props.organizationLogo;
  }

  get brandKey(): string {
    return this._brandKey;
  }

  get brandName(): string {
    return this._brandName;
  }

  get brandLogo(): string | null {
    return this._brandLogo;
  }

  get organizationKey(): string {
    return this._organizationKey;
  }

  get organizationName(): string {
    return this._organizationName;
  }

  get organizationLogo(): string | null {
    return this._organizationLogo;
  }
}
